import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Journal, Region } from '../../shared/models/date-filter.model';
import {
    ChartFilters,
    SubmissionsCountData,
    PoolProgressionApiRow,
    SubmissionsStatsDataRow
} from './author-analytics.model';
import { BaseApiService } from '../../core/services/base-api.service';
import { AppConfigService } from '../../core/services/app-config.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorAnalyticsService extends BaseApiService {
    
    constructor(
        http: HttpClient,
        appConfigService: AppConfigService
    ) {
        super(http, appConfigService);
    }

    getJournals(): Observable<Journal[]> {
        return this.get<Journal[]>('master/journals');
    }

    getRegions(): Observable<Region[]> {
        return this.get<Region[]>('master/regions');
    }

    getActiveAuthorsData(filters: ChartFilters): Observable<any[]> {
        return this.get<any[]>('authors/active-authors', filters);
    }

    getPoolProgressionData(filters: ChartFilters): Observable<PoolProgressionApiRow[]> {
        return this.get<PoolProgressionApiRow[]>('authors/pool-progression', filters);
    }
 
    getSubmissionsStats(filters: ChartFilters): Observable<any[]> {
        return this.get<any[]>('authors/submissions-stats', filters);
    }

    getSubmissionsStatsData(filters: ChartFilters): Observable<SubmissionsStatsDataRow[]> {
        return this.get<SubmissionsStatsDataRow[]>('authors/submissions-data', filters);
    }

    getTransfersRetention(filters: ChartFilters): Observable<any[]> {
        return this.get<any[]>('authors/transfers-retention', filters);
    }

    getMarketingOptin(filters: ChartFilters): Observable<any[]> {
        return this.get<any[]>('authors/marketing-optin', filters);
    }

    getAvgSubmittedPublished(filters: ChartFilters): Observable<any[]> {
        return this.get<any[]>('authors/avg-submitted-published', filters);
    }

    getSubmissionsCount(filters: ChartFilters): Observable<SubmissionsCountData[]> {
        return this.get<SubmissionsCountData[]>('authors/submissions-count', filters);
    }
} 